const CHANGE_STATUS = {
    ADD: "add",
    EDIT: "edit",
    DELETE: "delete"
}

export {
    CHANGE_STATUS
}